import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cd49988"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row pb-1 pt-1" }
const _hoisted_2 = { class: "flex xs2 offset--xs10" }
const _hoisted_3 = {
  key: 0,
  class: "pt-3"
}
const _hoisted_4 = {
  class: "flex sm12",
  style: {"text-align":"center"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" There are no Groups yet. Click to add your first Group. ")
const _hoisted_6 = {
  key: 1,
  class: "row gutter--md mb-5"
}
const _hoisted_7 = { class: "flex xs12 lg8" }
const _hoisted_8 = { class: "row gutter--md" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "minor" }
const _hoisted_11 = {
  class: "flex xs12 md6 lg4",
  key: "Ungrouped",
  ref: "ungrouped"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Ungrouped Subscriptions")

import GroupView from "@/components/GroupView.vue";
import SubscriptionListItem from "@/components/SubscriptionListItem.vue";
import { Group } from "@/models/Group";
import { Subscription } from "@/models/Subscription";
import { load } from "dotenv";
import Moralis from "moralis";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import draggable from "vuedraggable";
import { useGroupsStore } from "@/store/pinia_group";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  emits: ["newGroup"],
  setup(__props, { emit }) {


const ungroupedLoading = ref(false);
const groupsStore = useGroupsStore();

const refresh = () => {
  groupsStore.fetchGroups();
  fetchUngroupedSubs();
};

const fetchUngroupedSubs = async (): Promise<void> => {
  ungroupedLoading.value = true;
  const g = new Group();
  ungroupedSubscriptions.value.length = 0;
  ungroupedSubscriptions.value.push(...(await g.subscriptions()));
  ungroupedLoading.value = false;
};

const ungroupedSubscriptions = ref<Subscription[]>([]);

onMounted(() => {
  groupsStore.fetchGroups();
  fetchUngroupedSubs();
});

const showNoGroups = computed((): boolean => {
  return !groupsStore.loading && groupsStore.groups.length == 0;
});

const addGroup = (): void => {
  groupsStore.groups.push(Group.spawn());
  emit("newGroup");
};

const destroyGroup = async (delGroup: Group) => {
  if (delGroup.id) {
    await delGroup.destroy();
  } else {
    groupsStore.removeGroup(delGroup);
  }
};

const checkMove = (event: any) => {
  return false;
};

const dragChange = async (event: any) => {
  if (event.added) {
    event.added.element.group = undefined;
    event.added.element.save();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_va_list = _resolveComponent("va-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_va_button, {
          icon: "refresh",
          color: "secondary",
          onClick: refresh
        }),
        _createVNode(_component_va_button, {
          onClick: _withModifiers(addGroup, ["prevent"]),
          "icon-right": "add",
          size: "medium",
          class: "ml-4",
          color: "success"
        }, null, 8, ["onClick"])
      ])
    ]),
    (_unref(showNoGroups))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", null, [
              _hoisted_5,
              _createVNode(_component_va_button, {
                onClick: _withModifiers(addGroup, ["prevent"]),
                "icon-right": "add",
                size: "large",
                color: "success"
              }, null, 8, ["onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(showNoGroups))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupsStore).groups, (group) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex xs12 md6",
                  key: group.id
                }, [
                  _createVNode(_component_va_inner_loading, {
                    loading: _unref(groupsStore).loading
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_card, { outlined: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_card_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_va_chip, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(group.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("span", _hoisted_10, "Next: " + _toDisplayString(group.prettyNextSend()), 1),
                                _createVNode(_component_va_button, {
                                  class: "rightButton",
                                  onClick: ($event: any) => (destroyGroup(group)),
                                  "icon-right": "delete",
                                  size: "small",
                                  color: "danger"
                                }, null, 8, ["onClick"])
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_va_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode(GroupView, {
                                group: group,
                                showSubscriptions: true
                              }, null, 8, ["group"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["loading"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_va_card, { outlined: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_va_card_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_chip, { color: "warning" }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_inner_loading, { loading: ungroupedLoading.value }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_card_content, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(draggable), {
                              modelValue: ungroupedSubscriptions.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ungroupedSubscriptions).value = $event)),
                              group: "subscriptions",
                              onStart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drag = true)),
                              onEnd: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drag = false)),
                              onChange: dragChange,
                              "item-key": "id",
                              sort: false
                            }, {
                              item: _withCtx(({ element }) => [
                                _createVNode(SubscriptionListItem, {
                                  subscription: element,
                                  draggable: true
                                }, null, 8, ["subscription"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ], 512)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})